import * as React from "react";

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  width?: number | string;
  height?: number | string;
  priority?: boolean;
  onLoadingComplete?: () => void;
}

/**
 * Shim for next/image - provides a standard img tag with compatible API
 * for use outside of Next.js environments
 */
const Image = React.forwardRef<HTMLImageElement, ImageProps>(
  ({ src, alt, width, height, priority, onLoadingComplete, ...props }, ref) => {
    const handleLoad = React.useCallback(() => {
      onLoadingComplete?.();
    }, [onLoadingComplete]);

    return (
      <img
        ref={ref}
        src={src}
        alt={alt}
        width={width}
        height={height}
        onLoad={handleLoad}
        loading={priority ? "eager" : "lazy"}
        {...props}
      />
    );
  }
);

Image.displayName = "Image";

export default Image;
